
import React, { Component } from 'react';
import { ActionInterface, ActionTakenType,  createActionTaken } from '@swivl/swivl-lib'


import './MultiSelect.scss';
import { ListItemData } from '../../ListItem';
import { MessageHandlerInterface } from '../../../../messages/MessageHandler';
import { Config } from '../../../../Config/Config';


interface MultiSelectOptionProps {
  isSelectable:boolean;
  action:ActionInterface;
  actionSelected(item:ActionInterface):void;
  selectedActions:Array<string>;
}

class MultiSelectOption extends React.Component<MultiSelectOptionProps> {
  constructor(props:MultiSelectOptionProps) { super(props); this.onClick = this.onClick.bind(this) }
  onClick() { 
    if (!Config.canPressButtons) { 
      return; 
    }
    
    this.props.actionSelected(this.props.action) }
  render () {

    const selected = this.props.selectedActions.includes(this.props.action.text);
    const onClick = (this.props.isSelectable) ? this.onClick : null;
    let className = "scc-multiSelectButton swivl-svgButton";

    if (this.props.isSelectable) {
      className += " swivl-primaryButton isSelectable"

      if (selected) {
        className += " swivl-primaryButton active"

      }
    } else {
      if (selected) {
        className += " swivl-primaryButton active"
      } else {
        className += " swivl-userBubble"
      }
    }

    let checkMark = (!selected) ? null : <svg style={{width:"15x", height:"11px"}}>
            <polygon id="Check" fillRule="nonzero" points="3.06066017 3.92977245 0.939339828 6.0510928 5.77480322 10.8865562 14.6006992 2.06066017 12.4793789 -0.0606601718 5.77480322 6.6439155"></polygon>
    </svg>;

    let checkBox = <div className="scc-multiSelectButtonCheckBoxWrapper"><div className="scc-multiSelectButtonCheckBox">{checkMark}</div></div>
    return <div className={className} onClick={onClick}>{checkBox}{this.props.action.text}</div>
  }
}


export interface MultiSelectProps {
  item:ListItemData;
  messageHandler:MessageHandlerInterface;
}
export interface MultiSelectState {
  selectedActions:Array<string>;
}

export class MultiSelect extends React.Component<MultiSelectProps,MultiSelectState> {
  constructor(props:MultiSelectProps) {
      super(props);
      this.state = {selectedActions:[]}

      // const selectedActions = (props.item.selectedActions) ? props.item.selectedActions: [];
      // const isSaved = typeof props.item.selectedActions == "object";
      //
      // this.state =  {selectedActions:selectedActions, isSaved:isSaved}
      this.actionSelected  = this.actionSelected.bind(this)
      this.submitClicked   = this.submitClicked.bind(this)
  }

  // selectedActionsForItem()

  actionSelected(action:ActionInterface) {
    if (!Config.canPressButtons) { 
      return; 
    }
    let selectedActions = this.state.selectedActions;


    
    if (selectedActions.includes(action.text)) {

      
      for (var i = 0; i < selectedActions.length; i++) {
        if (selectedActions[i] == action.text)  {

          
          selectedActions.splice(i,1);
          break;
        }
      }
    } else {
      selectedActions.push(action.text);
    }
    this.setState({selectedActions:selectedActions})
  }

  submitClicked() {
    if (!Config.canPressButtons) { 
      return; 
    }
    const messageId = this.props.item.message.id;
    const actionTaken = createActionTaken(ActionTakenType.Selected, this.state.selectedActions.join(','))

    this.props.messageHandler.actionTaken(messageId, actionTaken);
  }


  render() {
    const item:any = this.props.item;
    const actions:Array<ActionInterface> = item.message?.payload.actions;

    const actionTaken = this.props.item.message.actionTaken;
    let selectedActions  = this.state.selectedActions;
    let canSelect = true;
    if (actionTaken) {

      if (actionTaken.type == ActionTakenType.Selected && actionTaken.target && typeof actionTaken.target === 'string') {
        selectedActions = actionTaken.target.split(',');
        canSelect = false;
      }
    }

    const buttons = actions.map((item, _) => {

        return <MultiSelectOption
                key={item.id}
                action={item}
                actionSelected={this.actionSelected}
                selectedActions={selectedActions}
                isSelectable={canSelect} />

    })

    const saveButton = (canSelect) ? <div className="scc-multiSelectSaveButton swivl-primaryButton" onClick={this.submitClicked}>SUBMIT</div> : null;

    return <div className="scc-messageGroup">
        <div className="scc-multiSelectActions">
        {buttons}
        {saveButton}
      </div>


    </div>
  }

}
